import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { fetchNotices, selectRecentImportantNotices } from '../../store/noticesSlice'

import BG1 from '../../assets/images/202108251530400009_2_half-min.jpg'


const NoticeBar = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const fetchStatus = useSelector(state => state.notices.fetchStatus)
  useEffect(() => {
    if (fetchStatus === 'idle') {
      dispatch(fetchNotices())
    }
  }, [fetchStatus, dispatch])
  const importantNotice = useSelector(selectRecentImportantNotices)
  if (!importantNotice) {
    return null
  }

  return (
    <div className="main_notice_container container">
      <div id="main_notice" className="main_notice ">
        <div className="main_notice_inner row">
          <div className="col row l10 m12 s12">
            <div className="main_notice_title col s12 l2 left-align"><span>{t('menu.notices')}</span></div>
            <span className="inline-block point-border hide show-tablet-sm"></span>
            <div className="main_notice_divider col s12 l1 hide-on-med-only hide-on-small-only show-on-large"></div>
            <div className="main_notice_text col s12 l9">
              <span><Link to={`/intro/notices/${importantNotice.id}`} className="truncate">{importantNotice.title}</Link></span>
            </div>
          </div>
          <div className="col row l2 m12 s12 right-align">
            <div className="main_notice_date">
              <span className="main_notice_date_d">{importantNotice.lastModified && importantNotice.lastModified.slice(0, 10)}</span>
              <span className="main_notice_date_i"><Link to="/intro/notices/"><i className="ion ion-md-add"></i></Link></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export const Home = () => {
  useEffect(() => {
    window.$('.visual-area .slider').bxSlider({
      auto:true,
      speed:500,
      pause:5000,
      mode: 'fade',
      pager:false,
      autoHover: true,
      responsive: true,
      onSlideAfter 	: function($slideElement, oldIndex, newIndex)
        {
          window.$('.visual-area .slider > li').removeClass('active');
          window.$('.visual-area .slider > li').eq(newIndex).addClass('active');
        }
    });
    setTimeout(function(){window.$('.visual-area .slider > li:first-child').addClass('active');}, 200);
  }, [])

  // let openNoticeClicked = (e) => {
  //   e.preventDefault();
  //   console.log('openNoticeClicked');
  // }

  return (
    <div className="position-relative">
      <div className="visual-area">
        <ul className="slider">
          <li className="mv01">
            <div className="bg">
              <img src={BG1} alt="두 번째 배경 이미지" />
            </div>
            <div className="container">
              <div className="text-area scale-transition">
                <strong>EARTHQUAKE<br />RESEARCH<br />INFORMATION</strong>
                <p>
                  국민의 삶의 질 향상과<br className="show-tablet hide"/> 국민 행복 추구에 기여하겠습니다. <br />
                  (한국지질자원연구원 지리산 종합지진관측소 전경)
                </p>
              </div>
            </div>
          </li>
          <li className="mv02">
            <div className="bg">
              <img src={BG1} alt="두 번째 배경 이미지" />
            </div>
            <div className="container">
              <div className="text-area">
              <strong>EARTHQUAKE<br />RESEARCH<br />INFORMATION</strong>
                <p>
                  국민의 삶의 질 향상과<br className="show-tablet hide"/> 국민 행복 추구에 기여하겠습니다. <br />
                  (한국지질자원연구원 지리산 종합지진관측소 전경)
                </p>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <NoticeBar />
    </div>
  );
}




